import { FC } from "react"
import { Stack } from "@mui/material"
import { AutocompleteElement, TextFieldElement } from "react-hook-form-mui"
import { RtkHookForm } from "@/core/components"
import { GuestBot } from "../../interfaces"
import { usePatchBotMutation } from "../../store"

interface IProps {
  bot: GuestBot.Bot
  onDone?: () => void
}
interface FormData {
  status: GuestBot.Status
  delaySeconds: number
}

const STATUS_OPTIONS = [
  { id: "working", label: "Включён" },
  { id: "banned", label: "Выключен" },
]

export const UpdateGuestBotForm: FC<IProps> = ({ bot, onDone }) => (
  <RtkHookForm<FormData, GuestBot.PatchBotRes>
    mutationHook={usePatchBotMutation as never}
    formContextParams={{
      defaultValues: { status: bot.status, delaySeconds: bot.delaySeconds },
    }}
    getSubmitHandlerParams={(data) => ({
      pathParams: { id: bot.id },
      body: { status: data.status, delaySeconds: Number(data.delaySeconds) },
    })}
    afterSubmit={() => onDone?.()}
    successMessage="Бот обновлён"
    actions={[
      {
        text: "Сохранить",
        type: "submit",
        variant: "contained",
        fullWidth: true,
      },
    ]}
  >
    <Stack spacing={2}>
      <AutocompleteElement
        name="status"
        label="Статус"
        options={STATUS_OPTIONS}
        autocompleteProps={{
          getOptionLabel: (o) => o.label,
          disableClearable: true,
        }}
        matchId
      />
      <TextFieldElement
        name="delaySeconds"
        label="Задержка ответа (сек, 0–180)"
        type="number"
        fullWidth
        validation={{
          min: { value: 0, message: "Минимум 0" },
          max: { value: 180, message: "Максимум 180" },
        }}
      />
    </Stack>
  </RtkHookForm>
)
